import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { PRICES } from '../data/funnel';
import { sumUsd } from '../utils/currency';
interface OrderState {
  buyerName: string;
  buyerEmail: string;
  hasBump: boolean;
  hasMasterclass: boolean;
  setBuyer: (name: string, email: string) => void;
  toggleBump: () => void;
  addMasterclass: () => void;
  total: number;
}
const OrderContext = createContext<OrderState | null>(null);
export function OrderProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [buyerName, setBuyerName] = useState('');
  const [buyerEmail, setBuyerEmail] = useState('');
  const [hasBump, setHasBump] = useState(false);
  const [hasMasterclass, setHasMasterclass] = useState(false);
  const setBuyer = useCallback((name: string, email: string) => {
    setBuyerName(name);
    setBuyerEmail(email);
  }, []);
  const toggleBump = useCallback(() => setHasBump(v => !v), []);
  const addMasterclass = useCallback(() => setHasMasterclass(true), []);
  const total = useMemo(() => sumUsd(PRICES.blueprint, hasBump ? PRICES.bump : 0, hasMasterclass ? PRICES.masterclass : 0), [hasBump, hasMasterclass]);
  const value = useMemo(() => ({
    buyerName,
    buyerEmail,
    hasBump,
    hasMasterclass,
    setBuyer,
    toggleBump,
    addMasterclass,
    total
  }), [buyerName, buyerEmail, hasBump, hasMasterclass, setBuyer, toggleBump, addMasterclass, total]);
  return <OrderContext.Provider value={value} data-id="element-36" data-mp="mjsisxnz6z11">{children}</OrderContext.Provider>;
}
export function useOrder(): OrderState {
  const ctx = useContext(OrderContext);
  if (!ctx) throw new Error('useOrder must be used inside OrderProvider');
  return ctx;
}